import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForbidden = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M41 51C41 73.5 65 89.5 65 89.5C65 89.5 51 58 48.5 47.5C46 37 44 20 44 20L41 51Z",
			fill: "#6C6DCE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M70.7841 88.2708L90.278 95.913C90.4247 95.9705 90.5809 96 90.7384 96C91.4352 96 92 95.4352 92 94.7384V3.67199C92 3.28258 91.9114 2.89828 91.7409 2.54817L91.6909 2.44559C91.0532 1.13588 89.4243 0.662665 88.184 1.42673C88.0616 1.50217 87.946 1.58819 87.8385 1.6838L86.3863 2.97607C82.5577 6.38284 77.7605 8.5454 72.6366 8.63989C63.4493 8.80931 52.6653 8.2139 50 8.2139C47.2954 8.2139 41.9036 3.30898 39.5927 1.07973C38.9853 0.49381 38.0143 0.498726 37.4254 1.10329C37.1527 1.38337 37 1.75889 37 2.14987V13.3476V43.6364C37 43.8018 37.0003 43.9651 37.0009 44.1261C37.0289 51.8828 40.5321 59.7619 44.1864 66.6039C46.0447 70.083 48.5571 73.1706 51.5859 75.6973L56.5798 79.8634C60.8321 83.4108 65.6284 86.2496 70.7841 88.2708Z",
			fill: "#A8AAE3"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_943_17805",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 37,
			y: 0,
			width: 55,
			height: 96,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M70.7841 88.2708L90.278 95.913C90.4247 95.9705 90.5809 96 90.7384 96C91.4352 96 92 95.4352 92 94.7384V3.67199C92 3.28258 91.9114 2.89828 91.7409 2.54817L91.6909 2.44559C91.0532 1.13588 89.4243 0.662665 88.184 1.42673C88.0616 1.50217 87.946 1.58819 87.8385 1.6838L86.3863 2.97607C82.5577 6.38284 77.7605 8.5454 72.6366 8.63989C63.4493 8.80931 52.6653 8.2139 50 8.2139C47.2954 8.2139 41.9036 3.30898 39.5927 1.07973C38.9853 0.49381 38.0143 0.498726 37.4254 1.10329C37.1527 1.38337 37 1.75889 37 2.14987V13.3476V43.6364C37 43.8018 37.0003 43.9651 37.0009 44.1261C37.0289 51.8828 40.5321 59.7619 44.1864 66.6039C46.0447 70.083 48.5571 73.1706 51.5859 75.6973L56.5798 79.8634C60.8321 83.4108 65.6284 86.2496 70.7841 88.2708Z",
				fill: "#A8AAE3"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_943_17805)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M56 53V53C56.8794 51.0212 59.5822 50.7603 60.824 52.5342L61.5 53.5",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M61 49.5V49.5C61.8794 47.5212 64.5822 47.2603 65.824 49.0342L66.5 50",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51 48.5V48.5C51.8794 46.5212 54.5822 46.2603 55.824 48.0342L56.5 49",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68 52.5V52.5C68.8794 50.5212 71.5822 50.2603 72.824 52.0342L73.5 53",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M63 57.5V57.5C63.8794 55.5212 66.5822 55.2603 67.824 57.0342L68.5 58",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M68 47.5V47.5C68.8794 45.5212 71.5822 45.2603 72.824 47.0342L73.5 48",
					stroke: "#6C6DCE",
					strokeWidth: .3,
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M84 51.5C84 74 93.5 99.5 93.5 99.5V23.5V19C90.4342 25.1316 84.1404 40.5539 84.0308 47.4084C84.0107 48.6641 84 50.0251 84 51.5Z",
					fill: "#8588D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M90 75.5C90 98 95.5 108.5 95.5 108.5V32.5C95.5 31.9149 94.7221 31.8301 94.6125 32.4049C93.0566 40.5637 90 58.7265 90 75.5Z",
					fill: "#321F8D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M37 53.5C37 76 58 89.5 58 89.5C58 89.5 44 58 41.5 47.5C39 37 37 20 37 20V53.5Z",
					fill: "#8588D8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M52.5 76.5C52.5 76.5 35 76 35 53.5L36.7454 28.6287C36.6347 25.6088 37 25 37 25L36.7454 28.6287C36.8589 31.7287 37.4739 37.3693 39.5 47.5C43.5 67.5 52.5 76.5 52.5 76.5Z",
					fill: "#4F49BA"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 54,
			cy: 26,
			r: 8,
			fill: "white",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 74,
			cy: 26,
			r: 8,
			fill: "white",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64 34L67 37L64 40L61 37L64 34Z",
			fill: "#3F34A2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.5,
			y: 28,
			width: 1,
			height: 40,
			fill: "black",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 4.5,
			y: 27.5,
			width: 23,
			height: 23,
			rx: 11.5,
			fill: "white",
			stroke: "#4F49BA"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_943_17805)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16 49C10.477 49 6 44.523 6 39C6 33.477 10.477 29 16 29C21.523 29 26 33.477 26 39C26 44.523 21.523 49 16 49ZM20.891 35.523C20.5015 34.9764 20.0236 34.4985 19.477 34.109L11.109 42.477C11.4985 43.0236 11.9764 43.5015 12.523 43.891L20.891 35.523Z",
				fill: "#FF7A5D"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 52,
			cy: 29,
			r: 3,
			fill: "black",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 72,
			cy: 28,
			r: 3,
			fill: "black",
			fillOpacity: .94
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 69C0 69 19.5 66 40 66C60.5 66 96 69 96 69V70C96 70 55.5 67 40 67C24.5 67 0 70 0 70V69Z",
			fill: "#4F49BA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 55.5918,
			y: 63.1719,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-8 55.5918 63.1719)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 72,
			y: 63.2773,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-8 72 63.2773)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 57.5,
			y: 63.3477,
			width: 2,
			height: 4.63157,
			rx: 1,
			transform: "rotate(-11 57.5 63.3477)",
			fill: "#3F34A2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.9082,
			y: 63.4531,
			width: 2,
			height: 4.63157,
			rx: 1,
			transform: "rotate(-11 73.9082 63.4531)",
			fill: "#3F34A2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 59.5,
			y: 63.207,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-5 59.5 63.207)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 75.9082,
			y: 63.3125,
			width: 2,
			height: 6,
			rx: 1,
			transform: "rotate(-5 75.9082 63.3125)",
			fill: "#321F8D"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_943_17805",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(4 27)"
			})
		}) })
	]
});
export default SvgForbidden;
